import * as React from 'react';
import { withTheme } from '../../../common/withTheme';
import FileUploadOnSubmit from '../FileDropZone/FileUploadOnSubmit';

interface IPlotPhotoUploadProps {
    className?: string;
    plotId: number;
}

interface IPlotPhotoUploadActions {
    uploadPlotPhotos(files: File[], plotId: number): void;
}

type PlotPhotoUploadAllProps = IPlotPhotoUploadProps & IPlotPhotoUploadActions

interface IPlotPhotoUploadState {
    files: any[];
}

class PlotPhotoUpload extends React.Component<PlotPhotoUploadAllProps, IPlotPhotoUploadState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            files: []
        };
    }

    onSubmit() {
        if (this.props.plotId && this.state.files && this.state.files.length > 0) {
            this.props.uploadPlotPhotos(this.state.files, this.props.plotId);
        } else {

        }
    }

    onDrop(files) {
        this.setState({ files });
    }

    onCancel() {
        this.setState({
            files: []
        });
    }

    render() {

        return (
            <div className={this.props.className}>
                <FileUploadOnSubmit
                    files={this.state.files}
                    maxFiles={1}
                    onCancel={() => this.onCancel()}
                    onDrop={(files) => this.onDrop(files)}
                    onSubmit={() => this.onSubmit()}
                    uploadText={"UPLOAD"}
                />
            </div>
        );
    }
}

export default withTheme<PlotPhotoUploadAllProps>(PlotPhotoUpload);
